export const DEALER_LOCATOR_ENDPOINT =
  "/dealer-showrooms/:makeMaskingName([a-zA-Z0-9-]+)/:cityMaskingName([a-zA-Z0-9-]+)/";

export const AD_SLOTS = {
  TOP_AD: {
    id: "div-gpt-ad-1419227721763-0",
    path: "/1017752/CarWale_Mobile_ROS_320x50",
    size: [
      [320, 50],
      [320, 100],
      [320, 150],
    ],
  },
  BOTTOM_AD: {
    id: "div-gpt-ad-1435297201507-0",
    path: "/1017752/CarWale_Mobile_ROS_300x250",
    size: [[300, 250]],
  },
};
